import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import IconButton from '@mui/material/IconButton';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import VerifiedIcon from '@mui/icons-material/Verified';
import PendingRoundedIcon from '@mui/icons-material/PendingRounded';

import {
    Search, Print,
    Save,
    DeleteForever,
    Add,
    Edit,
    HighlightOffRounded,
    SaveAlt,
    Quiz,
    TableRowsRounded,
} from "@mui/icons-material";
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import CheckIcon from '@mui/icons-material/Check';
import SyncIcon from '@mui/icons-material/Sync';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { MdRecycling } from "react-icons/md";
import { HiOutlineSave } from "react-icons/hi";
import { BiEdit } from "react-icons/bi";
import { FaRegEdit, FaEdit } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { FiCheckSquare, FiSend } from "react-icons/fi";
import { MdPassword } from "react-icons/md";
import { BsFileEarmarkExcel } from "react-icons/bs";
import { MdSupervisorAccount } from "react-icons/md";
import PropTypes, { any } from 'prop-types';
import { Theme } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { currentLanguage } from "service/CommonFunction/AxiosConfig";
const sizeDefault = { width: 40, height: 40 };
export const styleX = {
    btnSubmit: {
        color: "white",
        backgroundColor: "#212529",
        ":hover": {
            backgroundColor: "rgb(84, 87, 89)",
        },
    },
    btnCancel: {
        color: "white",
        backgroundColor: "#ed3847",
        ":hover": {
            backgroundColor: "rgb(220, 53, 69)",
        },
    },
    btnRemove: {
        color: "white",
        backgroundColor: "#ed3847",
        ":hover": {
            backgroundColor: "rgb(220, 53, 69)",
        },
    },
    btnDownload: {
        color: "#fff",
        backgroundColor: "#212529",
        borderColor: "#212529",
        "&:hover": {
            backgroundColor: "rgb(84, 87, 89)",
        },
        margin: 1,
    },
    btnSetting: {
        color: "#fff",
        backgroundColor: "#1976d2",
        "&:hover": {
            backgroundColor: "#0946a2",
        },
    },
    btnSave: {
        backgroundColor: "rgb(51, 166, 76)",
        ":hover": {
            backgroundColor: "rgb(24, 142, 50)",
        },
    },
    btnBack: {
        backgroundColor: "#a7a7a7",
        ":hover": {
            backgroundColor: "#878787",
        },
    },
    btnPreview: {
        backgroundColor: "#e39a2d",
        ":hover": {
            backgroundColor: "#b9812d",
        },
    },
    violetColor: {
        color: "#fff",
        backgroundColor: "#9e3eda",
        borderColor: "#9e3eda",
        ":hover": { bgcolor: "#671d96" },
    },
    btnClose: {
        backgroundColor: "#a7a7a7",
        ":hover": {
            backgroundColor: "#878787",
        },
    },
};

export const BtnAdd = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "เพิ่ม",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Add />}
                    variant="contained"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "" }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    color="primary"
                    onClick={onClick}
                    aria-label="add"
                >
                    <Add />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnLogout = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ออกจากระบบ",
    isCircleWithOutText = false,
    sx = {}
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    size="small"
                    startIcon={<LogoutRoundedIcon />}
                    variant="contained"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    sx={[{ display: isHidden ? "none" : "" }, { ...sx }]}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={[{ background: "#c82333", color: "#fff" }, { ...sx }]}
                    className={"btn-danger"}
                    onClick={onClick}
                    aria-label="add"
                >
                    <LogoutRoundedIcon />
                </Fab>
            )}
        </Tooltip>
    );
};

export const ButtonAdd = ({
    required = false,
    isDisabled = false,
    onClick = () => { },
    isHidden = false,
    txt = "เพิ่ม",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Add />}
                    variant="contained"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    color="primary"
                    onClick={onClick}
                    aria-label="add"
                >
                    <Add />
                </Fab>
            )}
        </Tooltip>
    );
}
ButtonAdd.defaultProps = {
    required: false,
    isDisabled: false,
    isHidden: false,
    txt: "เพิ่ม",
    isCircleWithOutText: false,
};
ButtonAdd.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    isDisabled: PropTypes.bool,
    isHidden: PropTypes.bool,
    txt: PropTypes.string,
    isCircleWithOutText: PropTypes.bool,
}

export const BtnSearch = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ค้นหา",
    isCircleWithOutText = false,
    Color = "#169bd5"
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Search style={{ color: "#ffffff" }} />}
                    variant="contained"
                    style={{ backgroundColor: Color }}
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="search"
                >
                    <Search />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnPrint = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "พิมพ์ทั้งหมด",
    isCircleWithOutText = false,
    Color = "#e0a800"
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Print style={{ color: "#ffffff" }} />}
                    variant="contained"
                    style={{ backgroundColor: Color }}
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="warning"
                    onClick={onClick}
                    aria-label="search"
                >
                    <Print />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnClear = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ล้าง",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<RefreshRoundedIcon className="icon-reverse" />}
                    variant="contained"
                    color="inherit"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="clear"
                >
                    <RefreshRoundedIcon className="icon-reverse" />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnCloseInModal = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ยกเลิก",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            <Fab
                sx={{ width: 40, height: 40 }}
                color="inherit"
                onClick={onClick}
            >
                <ClearRoundedIcon />
            </Fab>
        </Tooltip>
    );
};

export const BtnCancelInModal = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ยกเลิก",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    variant="contained"
                    color="inherit"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="clear"
                >
                    <RefreshRoundedIcon />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnCancel = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ยกเลิก",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<HighlightOffRounded />}
                    variant="contained"

                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "", backgroundColor: '#dcdcdc', color: '#000000' }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="cancel"
                >
                    <HighlightOffRounded />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnRemove = ({
    IsDisabled = false,
    IsHisabled = false,
    onClick = () => { },
    txt = "Remove",
    isCircleWithOutText = false,
    tooltipPlacement = "bottom"
}) => {
    return <Tooltip placement={tooltipPlacement as any} title={txt}>
        {!isCircleWithOutText ? (
            <Button
                variant="contained"
                size="small"
                startIcon={<DeleteForever />}
                disabled={IsDisabled === true ? true : false}
                hidden={IsHisabled === true ? true : false}
                onClick={onClick}
                sx={styleX.btnCancel}
            >
                {txt}
            </Button>
        ) : (
            <Fab
                sx={[styleX.btnCancel, { ...sizeDefault }]}
                onClick={onClick}
                aria-label="cancel"
                disabled={IsDisabled === true ? true : false}
            >
                <DeleteForever />
            </Fab>
        )}
    </Tooltip>

};

export const BtnBack = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "กลับ",
    Color = "#dcdbdb"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<ArrowBackIosRoundedIcon />}
                variant="contained"
                color="warning"
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                style={{ backgroundColor: Color, color: "#000000" }}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnRecomment = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ประเมินความพึงพอใจ",
    Color = "#66cc66"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<StarBorderIcon />}
                variant="contained"
                color="warning"
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                style={{ backgroundColor: Color, color: "#ffffff" }}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnWaiting = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "Waiting",
    isCircleWithOutText = false,
    sx = {},
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<PendingRoundedIcon />}
                    variant="contained"
                    color="warning"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "" }}
                    sx={{ sx }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="save"
                >
                    <TaskAltOutlinedIcon />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnSave = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "บันทึก",
    isCircleWithOutText = false,
    sx = {},
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<TaskAltOutlinedIcon />}
                    variant="contained"
                    color="success"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "" }}
                    sx={{ sx }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="save"
                >
                    <TaskAltOutlinedIcon />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnDelete = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ลบ",
    isCircleWithOutText = false,
    Color = "#169bd5"

}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<DeleteForever />}
                    variant="contained"
                    color="error"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <IconButton
                    sx={{ width: 40, height: 40 }}
                    color="error"
                    onClick={onClick}
                    aria-label="delete"
                >
                    <DeleteForever />
                </IconButton>
            )}
        </Tooltip>
    );
};

export const BtnDownload = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ดาวน์โหลด",
    isCircleWithOutText = false,
    Color = "#1000f3"
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<SaveAlt />}
                    variant="contained"
                    color="primary"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <IconButton
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="edit"
                >
                    <SaveAlt />
                </IconButton>
            )}
        </Tooltip>
    );
};

export const BtnEditOnTable = ({
    IsDisabled = false,
    IsHisabled = false,
    txt = "แก้ไข", //"Edit",
    onClick = () => { },
}) => (
    <Tooltip title={txt}>
        <GridActionsCellItem
            disabled={IsDisabled}
            hidden={IsHisabled}
            icon={<Edit />}
            label={txt}
            sx={
                IsHisabled !== true ? {
                    backgroundColor: "#ffc107",
                    color: "white",
                    ":hover": { bgcolor: "#cc9900" },
                    margin: "1%",
                }
                    :
                    {
                        display: "none",
                        backgroundColor: "#ffc107",
                        color: "white",
                        ":hover": { bgcolor: "#cc9900" },
                        margin: "1%",
                    }
            }
            onClick={onClick}
            aria-label={txt}
        />
    </Tooltip>
)

export const BtnEdit = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "แก้ไข",
    isCircleWithOutText = false,
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Edit />}
                    variant="contained"
                    color="warning"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                >
                    {txt}
                </Button>
            ) : (
                <IconButton
                    color="warning"
                    onClick={onClick}
                    aria-label="edit"
                >
                    <Edit />
                </IconButton>
            )}
        </Tooltip>
    );
};

export const BtnConfirm = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ยืนยัน",
    Color = "#169bd5"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<CheckIcon style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnRating = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ประเมินความพึงพอใจ",
    Color = "#66cc66"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<CheckIcon style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnChangePassword = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "เปลี่ยนรหัสผ่าน",
    Color = "#f59a23"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<RiLockPasswordFill style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnChangeProfile = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "เปลี่ยนรูปประจำตัว",
    Color = "#f59a23"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<MdPassword style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnReject = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ไม่ยอมรับการแก้ไข",
    Color = "#d9001b"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<CloseRoundedIcon style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={{
                    backgroundColor: "#d9001b",
                    color: "white",
                    ":hover": { 
                        bgcolor: "#960315 !important" 
                    },
                }}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnRejectPart = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ไม่ยอมรับข้อร้องเรียน",
    Color = "#d9001b"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<ReplyRoundedIcon style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, display: isHidden ? "none" : "" }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={{
                    backgroundColor: "#d9001b",
                    color: "white",
                    ":hover": { 
                        bgcolor: "#960315 !important" 
                    },
                }}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};


export const BtnAddPerson = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "เพิ่มผู้อบรม",
    Color = "#169bd5"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<PersonAddAlt1Icon style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnFile = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "",
    Color = "#3182CE"
}) => {
    return (
        <Tooltip title={txt}>
            <IconButton
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                <InsertDriveFileIcon style={{ color: Color }} />
            </IconButton>
        </Tooltip>
    );
};

export const BtnUpdate = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "อัปเดต",
    Color = "#1976d2"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<FaEdit style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnSend = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "ส่ง",
    Color = "#1976d2",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<FiSend style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: theme.palette.info.main,
                    borderColor: theme.palette.info.light,
                    ":hover": { bgcolor: theme.palette.info.dark },
                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnHome = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "กลับสู่หน้าหลัก",
    Color = "#dcdcdc",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<HomeIcon style={{ color: "#000000" }} />}
                variant="contained"
                style={{ backgroundColor: Color, color: "#000000", ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: "#b8b8b8",
                    borderColor: "#b8b8b8",
                    ":hover": { bgcolor: "#b8b8b8" },
                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};



export const BtnAddForm = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "แจ้งปัญหาเพิ่มเติม",
    Color = "#1976d2",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<BiEdit style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, color: "#ffffff", ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: "#b8b8b8",
                    borderColor: "#b8b8b8",
                    ":hover": { bgcolor: "#b8b8b8" },
                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnExportExcel = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "Excel",
    Color = "#66cc66",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<BsFileEarmarkExcel style={{ color: "#ffffff" }} />}
                variant="contained"
                // style={{ backgroundColor: Color, color: "#ffffff", ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: Color,
                    borderColor: Color,
                    ":hover": { bgcolor: "#5a915a" },
                    ".Mui-disabled": {
                        color: 'rgba(0, 0, 0, 0.26)',
                        boxShadow: 'none',
                        backgroundColor: 'rgba(0, 0, 0, 0.12)'
                    }

                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnDraft = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "บันทึกร่าง",
    Color = "#3cc1ac",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<HiOutlineSave style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, color: "#ffffff", ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: "#3cc1ac",
                    borderColor: "#3cc1ac",
                    ":hover": { bgcolor: "#239b88" },
                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnRecycle = ({
    isDisabled = false,
    isHidden = false,
    onClick,
    txt = "เปิดคำร้องใหม่",
    Color = "#f59a23",
    btnStyle = {}
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<MdRecycling style={{ color: "#ffffff" }} />}
                variant="contained"
                style={{ backgroundColor: Color, color: "#ffffff", ...btnStyle }}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                sx={(theme: Theme) => ({
                    color: "#fff",
                    backgroundColor: "#f59a23",
                    borderColor: "#f59a23",
                    ":hover": { bgcolor: "#e6880c" },
                })}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnSearchOnTable = ({
    IsDisabled = false,
    IsHisabled = false,
    txt = "ดู", //"Search",
    onClick = () => { },
}) => (
    <Tooltip title={txt}>
        <GridActionsCellItem
            disabled={IsDisabled}
            hidden={IsHisabled}
            icon={<Search />}
            label={txt}
            sx={{
                backgroundColor: "#096ddd",
                // backgroundColor: "#1000f3",
                color: "white", //black
                ":hover": { bgcolor: "#004290" },
                // ":hover": { bgcolor: "#2d22b9" },
            }}
            onClick={onClick}
            aria-label={txt}
        />
    </Tooltip>
)

export const BtnVerifyOnTable = ({
    IsDisabled = false,
    IsHisabled = false,
    txt = "Activate",
    onClick = () => { },
}) => (
    <Tooltip title={txt}>
        <GridActionsCellItem
            disabled={IsDisabled}
            hidden={IsHisabled}
            icon={<VerifiedIcon />}
            label={txt}
            sx={{
                backgroundColor: "#C69749",
                // backgroundColor: "#1000f3",
                color: "#FFFFFF", //black
                ":hover": { bgcolor: "#FDDD5C" },
                // ":hover": { bgcolor: "#2d22b9" },
            }}
            onClick={onClick}
            aria-label={txt}
        />
    </Tooltip>
)

export const BtnIcon = ({
    isDisabled = false,
    onClick = () => { },
    startIcon = <BiEdit />,
    style = {},
    txtTooltip = "",
    BackgroungColor = "#000000",
    BorderColor = "#000000",
    HoverBackgroungColor = "",
}) => {
    return (
        <Tooltip title={txtTooltip}>
            <Button
                startIcon={startIcon}
                variant="contained"
                style={style}
                onClick={onClick}
                disabled={isDisabled ? true : false}
                sx={{
                    backgroundColor: BackgroungColor,
                    width: "36.5px",
                    minWidth: "20px",
                    height: "39.5px",
                    border: "1px solid",
                    borderColor: BorderColor,
                    ":hover": { bgcolor: HoverBackgroungColor },
                    "& .MuiButton-startIcon": { margin: 0 }
                }}
            />
        </Tooltip>
    );
};

export const BtnIconSearch = ({
    isDisabled = false,
    onClick = () => { },
}) => {
    return (
        <BtnIcon
            txtTooltip={currentLanguage() == "th" ? "ค้นหา" : "Search"}
            startIcon={<SearchIcon />}
            BackgroungColor="#3f51b5"
            BorderColor='#3f51b5'
            HoverBackgroungColor='#2b3fae'
            onClick={onClick}
        />
    );
};

export const BtnIconExcel = ({
    isDisabled = false,
    onClick = () => { },
}) => {
    return (
        <BtnIcon
            txtTooltip="Export"
            startIcon={<BsFileEarmarkExcel />}
            BackgroungColor="#66cc66"
            BorderColor='#66cc66'
            HoverBackgroungColor='#3fac3f'
            onClick={onClick}
        />
    );
};


